import { render, staticRenderFns } from "./CubeShadow.vue?vue&type=template&id=ee4d1284&scoped=true"
import script from "./CubeShadow.vue?vue&type=script&lang=js"
export * from "./CubeShadow.vue?vue&type=script&lang=js"
import style0 from "./CubeShadow.vue?vue&type=style&index=0&id=ee4d1284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4d1284",
  null
  
)

export default component.exports